import { CenterLite } from '../center-model/center-lite.model';

export class Ticket {

    private active: boolean;
    private centers: CenterLite[];
    private creationDate: number;
    private internalId: string;
    private modificationDate: number;
    private ticketHtml: string;
    private ticketName: string;
    private ticketText: string;
    private ticketHtmlFlag: boolean;
    private ticketTextFlag: boolean;

    constructor(active?: boolean, centers?: CenterLite[], creationDate?: number, internalId?: string, modificationDate?: number, ticketHtml?: string, ticketName?: string, ticketText?: string, ticketHtmlFlag?: boolean, ticketTextFlag?: boolean) {
        this.active = active;
        this.centers = centers;
        this.creationDate = creationDate;
        this.internalId = internalId;
        this.modificationDate = modificationDate;
        this.ticketHtml = ticketHtml;
        this.ticketName = ticketName;
        this.ticketText = ticketText;
        this.ticketHtmlFlag = ticketHtmlFlag;
        this.ticketTextFlag = ticketTextFlag;
    }

    public get Active() {
        return this.active;
    }
    public get Centers() {
        return this.centers;
    }
    public get CreationDate() {
        return this.creationDate;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get ModificationDate() {
        return this.modificationDate;
    }
    public get TicketHtml() {
        return this.ticketHtml;
    }
    public get TicketName() {
        return this.ticketName;
    }
    public get TicketText() {
        return this.ticketText;
    }
    public get TicketHtmlFlag() {
        return this.ticketHtmlFlag;
    }
    public get TicketTextFlag() {
        return this.ticketTextFlag;
    }
    public set Active(active) {
        this.active = active;
    }
    public set Centers(centers) {
        this.centers = centers;
    }
    public set CreationDate(creationDate) {
        this.creationDate = creationDate;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set ModificationDate(modificationDate) {
        this.modificationDate = modificationDate;
    }
    public set TicketHtml(ticketHtml) {
        this.ticketHtml = ticketHtml;
    }
    public set TicketName(ticketName) {
        this.ticketName = ticketName;
    }
    public set TicketText(ticketText) {
        this.ticketText = ticketText;
    }
    public set TicketHtmlFlag(ticketHtmlFlag) {
        this.ticketHtmlFlag = ticketHtmlFlag;
    }
    public set TicketTextFlag(ticketTextFlag) {
        this.ticketTextFlag = ticketTextFlag;
    }
}
